var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-row",
        { attrs: { dense: "" } },
        [
          _c(
            "v-col",
            { attrs: { cols: "12", sm: "6" } },
            [
              _c("Plotly", {
                attrs: {
                  data: _vm.annualLoadChart.data,
                  layout: _vm.annualLoadChart.layout,
                },
              }),
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12", sm: "6" } },
            [
              _c("p", { staticClass: "text-caption text-center mt-2 mb-0" }, [
                _vm._v("Peak demand based on the α and β formula"),
              ]),
              _c("Plotly", {
                attrs: {
                  data: _vm.peakLoadChart.data,
                  layout: _vm.peakLoadChart.layout,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-row",
        { attrs: { dense: "" } },
        [
          _c(
            "v-col",
            {
              staticStyle: { "max-width": "500px" },
              attrs: { cols: "12", lg: "4" },
            },
            [
              _vm.outputs.metrics
                ? _c(
                    "Widget",
                    { attrs: { title: "Regression Metrics", height: "100%" } },
                    [
                      _c("v-simple-table", {
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function () {
                                return [
                                  _c("tbody", [
                                    _c("tr", [
                                      _c(
                                        "td",
                                        [
                                          _vm._v(" Multiple R "),
                                          _c(
                                            "v-tooltip",
                                            {
                                              attrs: { top: "" },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "activator",
                                                    fn: function (ref) {
                                                      var on = ref.on
                                                      var attrs = ref.attrs
                                                      return [
                                                        _c(
                                                          "v-icon",
                                                          _vm._g(
                                                            _vm._b(
                                                              {
                                                                staticClass:
                                                                  "ml-1",
                                                                attrs: {
                                                                  small: "",
                                                                  color: "grey",
                                                                },
                                                              },
                                                              "v-icon",
                                                              attrs,
                                                              false
                                                            ),
                                                            on
                                                          ),
                                                          [
                                                            _vm._v(
                                                              "mdi-help-circle"
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                false,
                                                16012890
                                              ),
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  "The correlation coefficient between observed and predicted values. Ranges from 0 to 1, where 1 indicates perfect correlation."
                                                ),
                                              ]),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.formatMetricValue(
                                              _vm.outputs.metrics.multiple_r
                                            )
                                          )
                                        ),
                                      ]),
                                    ]),
                                    _c("tr", [
                                      _c(
                                        "td",
                                        [
                                          _vm._v(" R"),
                                          _c("sup", [_vm._v("2")]),
                                          _c(
                                            "v-tooltip",
                                            {
                                              attrs: { top: "" },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "activator",
                                                    fn: function (ref) {
                                                      var on = ref.on
                                                      var attrs = ref.attrs
                                                      return [
                                                        _c(
                                                          "v-icon",
                                                          _vm._g(
                                                            _vm._b(
                                                              {
                                                                staticClass:
                                                                  "ml-1",
                                                                attrs: {
                                                                  small: "",
                                                                  color: "grey",
                                                                },
                                                              },
                                                              "v-icon",
                                                              attrs,
                                                              false
                                                            ),
                                                            on
                                                          ),
                                                          [
                                                            _vm._v(
                                                              "mdi-help-circle"
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                false,
                                                16012890
                                              ),
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  "Coefficient of determination. Shows what percentage of variance in the data is explained by the model. 0-1 range, higher is better. 0.7+ is generally considered good."
                                                ),
                                              ]),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.formatMetricValue(
                                              _vm.outputs.metrics.r_square
                                            )
                                          )
                                        ),
                                      ]),
                                    ]),
                                    _c("tr", [
                                      _c(
                                        "td",
                                        [
                                          _vm._v(" Adjusted R"),
                                          _c("sup", [_vm._v("2")]),
                                          _c(
                                            "v-tooltip",
                                            {
                                              attrs: { top: "" },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "activator",
                                                    fn: function (ref) {
                                                      var on = ref.on
                                                      var attrs = ref.attrs
                                                      return [
                                                        _c(
                                                          "v-icon",
                                                          _vm._g(
                                                            _vm._b(
                                                              {
                                                                staticClass:
                                                                  "ml-1",
                                                                attrs: {
                                                                  small: "",
                                                                  color: "grey",
                                                                },
                                                              },
                                                              "v-icon",
                                                              attrs,
                                                              false
                                                            ),
                                                            on
                                                          ),
                                                          [
                                                            _vm._v(
                                                              "mdi-help-circle"
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                false,
                                                16012890
                                              ),
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  "R² adjusted for the number of predictors in the model. More reliable than R² when comparing models with different numbers of variables."
                                                ),
                                              ]),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.formatMetricValue(
                                              _vm.outputs.metrics
                                                .adjusted_r_square
                                            )
                                          )
                                        ),
                                      ]),
                                    ]),
                                    _c("tr", [
                                      _c(
                                        "td",
                                        [
                                          _vm._v(
                                            " Standard Error Regression (GWh) "
                                          ),
                                          _c(
                                            "v-tooltip",
                                            {
                                              attrs: { top: "" },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "activator",
                                                    fn: function (ref) {
                                                      var on = ref.on
                                                      var attrs = ref.attrs
                                                      return [
                                                        _c(
                                                          "v-icon",
                                                          _vm._g(
                                                            _vm._b(
                                                              {
                                                                staticClass:
                                                                  "ml-1",
                                                                attrs: {
                                                                  small: "",
                                                                  color: "grey",
                                                                },
                                                              },
                                                              "v-icon",
                                                              attrs,
                                                              false
                                                            ),
                                                            on
                                                          ),
                                                          [
                                                            _vm._v(
                                                              "mdi-help-circle"
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                false,
                                                16012890
                                              ),
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  "Average distance between observed and predicted values. Lower values indicate better model accuracy. Units match your dependent variable."
                                                ),
                                              ]),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c("td", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.formatMetricValue(
                                              _vm.outputs.metrics
                                                .standard_error_regression
                                            )
                                          )
                                        ),
                                      ]),
                                    ]),
                                  ]),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          4097537132
                        ),
                      }),
                      _c(
                        "v-expansion-panels",
                        { staticClass: "mt-3" },
                        [
                          _c(
                            "v-expansion-panel",
                            [
                              _c("v-expansion-panel-header", [
                                _c("span", { staticClass: "text-subtitle-2" }, [
                                  _vm._v("More"),
                                ]),
                              ]),
                              _c(
                                "v-expansion-panel-content",
                                [
                                  _c("v-simple-table", {
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function () {
                                            return [
                                              _c("tbody", [
                                                _c("tr", [
                                                  _c("td", [
                                                    _vm._v("Observations"),
                                                  ]),
                                                  _c("td", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.formatMetricValue(
                                                          _vm.outputs.metrics
                                                            .observations
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                ]),
                                                _c("tr", [
                                                  _c("td", [
                                                    _vm._v("F Statistic"),
                                                  ]),
                                                  _c("td", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.formatMetricValue(
                                                          _vm.outputs.metrics
                                                            .f_statistic
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                ]),
                                                _c("tr", [
                                                  _c("td", [
                                                    _vm._v(
                                                      "P value of F statistic"
                                                    ),
                                                  ]),
                                                  _c("td", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.formatMetricValue(
                                                          _vm.outputs.metrics
                                                            .p_value_f
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                ]),
                                                _c("tr", [
                                                  _c("td", [
                                                    _vm._v(
                                                      "Degrees of Freedom (Total)"
                                                    ),
                                                  ]),
                                                  _c("td", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.formatMetricValue(
                                                          _vm.outputs.metrics
                                                            .df_total
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                ]),
                                                _c("tr", [
                                                  _c("td", [
                                                    _vm._v(
                                                      "Degrees of Freedom (Regression)"
                                                    ),
                                                  ]),
                                                  _c("td", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.formatMetricValue(
                                                          _vm.outputs.metrics
                                                            .df_regression
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                ]),
                                                _c("tr", [
                                                  _c("td", [
                                                    _vm._v(
                                                      "Degrees of Freedom (Residual)"
                                                    ),
                                                  ]),
                                                  _c("td", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.formatMetricValue(
                                                          _vm.outputs.metrics
                                                            .df_residual
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                ]),
                                                _c("tr", [
                                                  _c("td", [
                                                    _vm._v(
                                                      "Sum of Squares (Total)"
                                                    ),
                                                  ]),
                                                  _c("td", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.formatMetricValue(
                                                          _vm.outputs.metrics
                                                            .ss_total
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                ]),
                                                _c("tr", [
                                                  _c("td", [
                                                    _vm._v(
                                                      "Sum of Squares (Regression)"
                                                    ),
                                                  ]),
                                                  _c("td", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.formatMetricValue(
                                                          _vm.outputs.metrics
                                                            .ss_regression
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                ]),
                                                _c("tr", [
                                                  _c("td", [
                                                    _vm._v(
                                                      "Sum of Squares (Residual)"
                                                    ),
                                                  ]),
                                                  _c("td", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.formatMetricValue(
                                                          _vm.outputs.metrics
                                                            .ss_residual
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                ]),
                                                _c("tr", [
                                                  _c("td", [
                                                    _vm._v(
                                                      "Mean Square (Regression)"
                                                    ),
                                                  ]),
                                                  _c("td", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.formatMetricValue(
                                                          _vm.outputs.metrics
                                                            .ms_regression
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                ]),
                                                _c("tr", [
                                                  _c("td", [
                                                    _vm._v(
                                                      "Mean Square (Residual)"
                                                    ),
                                                  ]),
                                                  _c("td", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.formatMetricValue(
                                                          _vm.outputs.metrics
                                                            .ms_residual
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                ]),
                                                _vm.outputs.metrics_ridge &&
                                                _vm.outputs.metrics_ridge
                                                  .intercept
                                                  ? _c("tr", [
                                                      _c("td", [
                                                        _vm._v("Intercept"),
                                                      ]),
                                                      _c("td", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.formatMetricValue(
                                                              _vm.outputs
                                                                .metrics_ridge
                                                                .intercept
                                                            )
                                                          )
                                                        ),
                                                      ]),
                                                    ])
                                                  : _vm._e(),
                                              ]),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      false,
                                      2538833690
                                    ),
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12", lg: "8" } },
            [
              _c(
                "Widget",
                {
                  attrs: {
                    title: "Feature Specific Regression Metrics",
                    height: "100%",
                  },
                },
                [
                  _c("v-simple-table", {
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function () {
                          return [
                            _c("thead", [
                              _c("tr", [
                                _c("th", [_vm._v("Feature")]),
                                _c(
                                  "th",
                                  [
                                    _vm._v(" Coefficient "),
                                    _c(
                                      "v-tooltip",
                                      {
                                        attrs: { top: "" },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "activator",
                                            fn: function (ref) {
                                              var on = ref.on
                                              var attrs = ref.attrs
                                              return [
                                                _c(
                                                  "v-icon",
                                                  _vm._g(
                                                    _vm._b(
                                                      {
                                                        staticClass: "ml-1",
                                                        attrs: {
                                                          small: "",
                                                          color: "grey",
                                                        },
                                                      },
                                                      "v-icon",
                                                      attrs,
                                                      false
                                                    ),
                                                    on
                                                  ),
                                                  [_vm._v("mdi-help-circle")]
                                                ),
                                              ]
                                            },
                                          },
                                        ]),
                                      },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            "The effect of each feature on the load. Positive values increase load, negative values decrease it. Larger absolute values indicate stronger influence."
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "th",
                                  [
                                    _vm._v(" Std Error "),
                                    _c(
                                      "v-tooltip",
                                      {
                                        attrs: { top: "" },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "activator",
                                            fn: function (ref) {
                                              var on = ref.on
                                              var attrs = ref.attrs
                                              return [
                                                _c(
                                                  "v-icon",
                                                  _vm._g(
                                                    _vm._b(
                                                      {
                                                        staticClass: "ml-1",
                                                        attrs: {
                                                          small: "",
                                                          color: "grey",
                                                        },
                                                      },
                                                      "v-icon",
                                                      attrs,
                                                      false
                                                    ),
                                                    on
                                                  ),
                                                  [_vm._v("mdi-help-circle")]
                                                ),
                                              ]
                                            },
                                          },
                                        ]),
                                      },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            "Uncertainty in the coefficient estimate. Smaller values indicate more precise estimates."
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "th",
                                  [
                                    _vm._v(" t-Stat "),
                                    _c(
                                      "v-tooltip",
                                      {
                                        attrs: { top: "" },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "activator",
                                            fn: function (ref) {
                                              var on = ref.on
                                              var attrs = ref.attrs
                                              return [
                                                _c(
                                                  "v-icon",
                                                  _vm._g(
                                                    _vm._b(
                                                      {
                                                        staticClass: "ml-1",
                                                        attrs: {
                                                          small: "",
                                                          color: "grey",
                                                        },
                                                      },
                                                      "v-icon",
                                                      attrs,
                                                      false
                                                    ),
                                                    on
                                                  ),
                                                  [_vm._v("mdi-help-circle")]
                                                ),
                                              ]
                                            },
                                          },
                                        ]),
                                      },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            "Test statistic for coefficient significance. Values > 2 or < -2 generally indicate statistical significance."
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "th",
                                  [
                                    _vm._v(" P-value "),
                                    _c(
                                      "v-tooltip",
                                      {
                                        attrs: { top: "" },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "activator",
                                            fn: function (ref) {
                                              var on = ref.on
                                              var attrs = ref.attrs
                                              return [
                                                _c(
                                                  "v-icon",
                                                  _vm._g(
                                                    _vm._b(
                                                      {
                                                        staticClass: "ml-1",
                                                        attrs: {
                                                          small: "",
                                                          color: "grey",
                                                        },
                                                      },
                                                      "v-icon",
                                                      attrs,
                                                      false
                                                    ),
                                                    on
                                                  ),
                                                  [_vm._v("mdi-help-circle")]
                                                ),
                                              ]
                                            },
                                          },
                                        ]),
                                      },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            "Probability that the coefficient is actually zero. Values < 0.05 indicate statistical significance at 95% confidence."
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "th",
                                  [
                                    _vm._v(" Lower 95% CI "),
                                    _c(
                                      "v-tooltip",
                                      {
                                        attrs: { top: "" },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "activator",
                                            fn: function (ref) {
                                              var on = ref.on
                                              var attrs = ref.attrs
                                              return [
                                                _c(
                                                  "v-icon",
                                                  _vm._g(
                                                    _vm._b(
                                                      {
                                                        staticClass: "ml-1",
                                                        attrs: {
                                                          small: "",
                                                          color: "grey",
                                                        },
                                                      },
                                                      "v-icon",
                                                      attrs,
                                                      false
                                                    ),
                                                    on
                                                  ),
                                                  [_vm._v("mdi-help-circle")]
                                                ),
                                              ]
                                            },
                                          },
                                        ]),
                                      },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            "Lower bound of the 95% confidence interval for the coefficient."
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "th",
                                  [
                                    _vm._v(" Upper 95% CI "),
                                    _c(
                                      "v-tooltip",
                                      {
                                        attrs: { top: "" },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "activator",
                                            fn: function (ref) {
                                              var on = ref.on
                                              var attrs = ref.attrs
                                              return [
                                                _c(
                                                  "v-icon",
                                                  _vm._g(
                                                    _vm._b(
                                                      {
                                                        staticClass: "ml-1",
                                                        attrs: {
                                                          small: "",
                                                          color: "grey",
                                                        },
                                                      },
                                                      "v-icon",
                                                      attrs,
                                                      false
                                                    ),
                                                    on
                                                  ),
                                                  [_vm._v("mdi-help-circle")]
                                                ),
                                              ]
                                            },
                                          },
                                        ]),
                                      },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            "Upper bound of the 95% confidence interval for the coefficient."
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                            ]),
                            _c(
                              "tbody",
                              _vm._l(_vm.featureNames, function (feature) {
                                return _c("tr", { key: feature }, [
                                  _c(
                                    "td",
                                    { staticClass: "font-weight-medium" },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.formatFeatureName(feature))
                                      ),
                                    ]
                                  ),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formatMetricValue(
                                          _vm.outputs.metrics_ridge
                                            .coefficients[feature]
                                        )
                                      )
                                    ),
                                  ]),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formatMetricValue(
                                          _vm.outputs.metrics_ridge
                                            .standard_errors[feature]
                                        )
                                      )
                                    ),
                                  ]),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formatMetricValue(
                                          _vm.outputs.metrics_ridge.t_stats[
                                            feature
                                          ]
                                        )
                                      )
                                    ),
                                  ]),
                                  _c("td", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.formatPValue(
                                            _vm.outputs.metrics_ridge
                                              .p_values_coefficients[feature]
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]),
                                  _c("td", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.formatMetricValue(
                                            _vm.outputs.metrics_ridge
                                              .confidence_intervals[feature][0]
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]),
                                  _c("td", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.formatMetricValue(
                                            _vm.outputs.metrics_ridge
                                              .confidence_intervals[feature][1]
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]),
                                ])
                              }),
                              0
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }